
import axios from 'axios'

export default class Request {

    static baseUrl
    static credentials = null
    static instance = null


    static init( credentials) {
        if (Request.credentials)
            console.warn('Request já inicializado.')


        Request.credentials = credentials

        Request.instance = new Request()
    }

    static getInstance() {

        if (!Request.instance)
            throw new Error('Request nao foi inicializado. Chamar metodo init().')

        return Request.instance
    }

    createGetRequest(reqUrl, params, headers, newApi, withCredentials, response) {
        return this._createRequest(reqUrl, 'GET', params, headers, newApi, withCredentials, response)
    }

    createPostRequest(reqUrl, params, headers, newApi, withCredentials) {
        return this._createRequest(reqUrl, 'POST', params, headers, newApi, withCredentials)
    }



    _createRequest(reqUrl, method, params = {}, headers = {}, newApi = false, withCredentials = true, response) {

        const _headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...headers
        }

        if (newApi)
            _headers.schema = Request.credentials.schema

        const axiosCfg = {
            url : newApi ? reqUrl : reqUrl ,
            method: method,
            headers: _headers,
            params:{},
            data: {},
        }

        if (response)
            axiosCfg.responseType = 'arraybuffer'

        if (method === 'GET')
            axiosCfg.params = params
        else
            axiosCfg.data = params


        if (withCredentials) {
            if (newApi) {
                axiosCfg.headers[ 'Authorization' ] = `Bearer ${Request.credentials.token}`
            } else  {
                //adiciona credentials no queryparams
                const {token, username} = Request.credentials
                axiosCfg.params.token = 'NTkzNjE2ZGUxNTMzMGMwZmIyZDU1ZTU1NDEwYmY5OTQ6Q0VOVFJBTF9ET19DTElFTlRFOjcxYjJINmJw'
                axiosCfg.params.username = username
            }
        }

        console.log({ axiosCfg })


        return axios(axiosCfg)
            .then((response) => {
               return response.data
            })

    }


}



// WEBPACK FOOTER //
// ./src/helpers/request-v2.js